import { type FacilityTransferDirectionPublicRecord, FacilityTransferDirection } from '@navio/nsdk';
import { useMemo } from 'react';
import { EmptyDay } from './EmptyDay';
import { OrderNotes } from './OrderNotes';
import { PickupRoundGroups } from './PickupRoundGroups';
import { compareByRoundThenOwnerThenPlate } from './pickupRounds';
import { RecentChanges } from './RecentChanges';

interface Props {
  incoming: FacilityTransferDirectionPublicRecord;
}

export const IncomingTab = ({ incoming }: Props) => {
  const sortedItems = useMemo(() => [...incoming.items].sort(compareByRoundThenOwnerThenPlate), [incoming.items]);

  if (incoming.items.length === 0) {
    return <EmptyDay />;
  }

  return (
    <div className='flex flex-col gap-4'>
      <RecentChanges changes={incoming.recentChanges} />
      <OrderNotes notes={incoming.notes} />
      <PickupRoundGroups items={sortedItems} rounds={incoming.rounds} direction={FacilityTransferDirection.INCOMING} />
    </div>
  );
};
